// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.phonenumbererror[data-v-ccefbc16] {\r\n  background: transparent;\r\n  color: red;\r\n  font-weight: bold;\n}\r\n", ""]);
// Exports
module.exports = exports;
